import { atom } from 'recoil';
import axios from '../utils/axios';
// eslint-disable-next-line import/extensions
import localStorageEffect from './localStorageEffect.js';
import { ProductSchedule, ProductScheduleItem } from '../@types/model/productSchedule';
import { ProductScheduleTemplateItem } from '../@types/model/productScheduleTemplate';

const productScheduleState = atom<ProductSchedule[]>({
  key: 'productSchedule',
  default: [],
  effects: [localStorageEffect('productSchedule')]
});

const getProductSchedule = async () => {
  const result = await axios.get('/api/v2/product-schedule');
  const included = result.data.included;
  const product_schedule_templates = included.filter((i: any) => {
    if (
      i?.type ===
      'App\\ProductSchedule\\Domain\\Model\\ProductScheduleTemplate\\ProductScheduleTemplate'
    )
      return true;
    return false;
  });
  let productSchedules: ProductSchedule[] = result.data.data.map((dat: any) => {
    const product_schedule_template_item = product_schedule_templates.find(
      (pst: any) => pst.guid === dat.attributes.template
    );
    let items: ProductScheduleTemplateItem[] = [];
    if (product_schedule_template_item) {
      Object.keys(product_schedule_template_item.attributes.items).forEach((key) => {
        items.push(
          product_schedule_template_item.attributes.items[key] as ProductScheduleTemplateItem
        );
      });
    }
    let schedulesT: ProductScheduleItem[] = [];
    if (dat.attributes.schedule) {
      Object.keys(dat.attributes.schedule).forEach((key) => {
        schedulesT.push(dat.attributes.schedule[key] as ProductScheduleItem);
      });
    }
    return {
      guid: dat.guid,
      // product_schedule_template: ProductScheduleTemplate | null;
      currentItem: dat.attributes.current_item,
      template: dat.attributes.template,
      configuration: {
        units: dat.attributes.configuration.units
      },
      devices: dat.attributes.devices,
      reference: dat.attributes.reference,
      state: dat.attributes.state,
      schedule: schedulesT,
      product_schedule_template: {
        guid: product_schedule_template_item?.guid,
        name: product_schedule_template_item?.attributes.name,
        type: product_schedule_template_item?.attributes.type,
        items: items
      }
    } as ProductSchedule;
  });
  return productSchedules;
};

export { productScheduleState, getProductSchedule };
